module.exports = __webpack_public_path__ + "static/media/protection.b4c56b53.svg";